<h3>{{ 'Sellers.Products.PromocodeName' | translate }}</h3>
<div>
  <form>
    <input type="text" [readonly]="true" value="{{promocode}}" #userinput>
  </form>
  <button class="btn btn-primary" aria-label="copy to clipboard" (click)="copyInputMessage(userinput)">
    <mat-icon style="color: #f3f3f3;">content_copy</mat-icon>
  </button>
</div>

